import React from 'react';
import { ChecklistProgram } from "../program/ChecklistProgram";

interface LmsPackageContent {
    title: string;
    contents: string[];
}

interface LmsPackageProps {
    packageName: string;
    gradientColors: string;
    textColors?: string;
    packageContents: LmsPackageContent[]
}

const LmsPackage: React.FC<LmsPackageProps> = ({ packageName, gradientColors, textColors, packageContents }) => {

    return (
        <div className={`container-lms relative rounded-xl ${gradientColors}`}>
            <div className='badge-lms relative'>
                <p className={`text-xl sm:text-xl font-semibold tracking-wider bg-clip-text mb-1 items-center justify-center mt-5 ${textColors}`}>{packageName}</p>
                <div className='mr-8 mb-2'>
                    <div className={`${textColors}`}>
                        {packageContents.map((content, contentIndex) => (
                            <div key={contentIndex}>
                                <p className="justify-start text-xs sm:text-xs font-normal ml-6 text-slate-400 bg-clip-text">{content.title}</p>
                                {content.contents.map((message, messageIndex) => (
                                    <div key={messageIndex} className={`${textColors}`}>
                                        <ChecklistProgram key={`${contentIndex}-${messageIndex}`} name={message} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LmsPackage;